/* Project Import will be here */
import * as actions from '../actions/device.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    device: {
        isDeviceAlreadyRegistered: false,
        deviceFingerPrintId: "",
        deviceId: null
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.DEVICE_REGISTRATION_SUCCESS:
            return {
                ...state,
                device: {
                    ...state.device,                  
                    isDeviceAlreadyRegistered: action.isDeviceAlreadyRegistered,
                    deviceFingerPrintId: action.deviceFingerPrintId,
                    deviceId: action.deviceId
                }
            };        

        default:
            return state;
    }
}